import React from 'react';

type DetailsButtonProps = {
  onClick: (e: React.MouseEvent) => void;
};

export const DetailsButton = ({ onClick }: DetailsButtonProps) => (
  <button
    type="button"
    className="hover:bg-negative bg-main-200 h-f2 w-f2 flex justify-center items-center"
    onClick={onClick}
    data-testid="details-button"
    aria-label="Details"
  >
    <div className="flex flex-col items-center gap-[2.5px]">
      <div className="w-[2.5px] h-[2.5px] rounded-full bg-main" />
      <div className="w-[2.5px] h-[2.5px] rounded-full bg-main" />
      <div className="w-[2.5px] h-[2.5px] rounded-full bg-main" />
    </div>
  </button>
);
